import { styled } from '@mui/material/styles';

export const Stepper = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
});
